import React from 'react';

import CveReferencesTable from '@totem/components/software/cves/CveReferencesTable';
import { CVERecord } from '@totem/components/software/cves/types';

type Props = {
  cve: CVERecord;
};

const CveReferences = ({ cve }: Props) => {
  return (
    <>
      <CveReferencesTable cve={cve} />
    </>
  );
};

export default CveReferences;
